"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryV2 = void 0;
const query_1 = require("../../core/query");
const queryBuilderV2_1 = require("./queryBuilderV2");
const abi_1 = require("../../core/lib/abi");
const paymentCalc_1 = require("./paymentCalc");
class QueryV2 extends query_1.Query {
    /**
     * @param config Axiom internal configuration parameters
     */
    constructor(config) {
        super(config);
    }
    /**
     * Creates a new `QueryBuilderV2`` instance
     * @param dataQuery (optional) An array of data subqueries to be included
     * @param computeQuery (optional) A compute query
     * @param callback (optional) The function on a contract to the called with the Query results
     * @param options (optional) Additional options for the Query
     * @returns
     */
    new(dataQuery, computeQuery, callback, options) {
        return new queryBuilderV2_1.QueryBuilderV2(this.config, dataQuery, computeQuery, callback, options);
    }
    /**
     *
     */
    async getBalance() {
        const axiomQueryAddr = this.config.getConstants().Addresses.AxiomQuery;
        const axiomQueryAbi = (0, abi_1.getAxiomQueryAbiForVersion)(this.config.version);
        const userAddress = this.config.signer?.address;
        if (userAddress === undefined) {
            throw new Error("Unable to get current balance: need to have a signer defined (private key must be input into `AxiomSdkCoreConfig`)");
        }
        return await paymentCalc_1.PaymentCalc.getBalance(this.config.providerUri, userAddress, axiomQueryAddr, axiomQueryAbi);
    }
}
exports.QueryV2 = QueryV2;
//# sourceMappingURL=queryV2.js.map